import React from 'react'

import styled from 'styled-components'

import { ArtistBalanceItemDate } from './ArtistBalanceItemDate'
import { ArtistBalanceItemTransactionType } from './ArtistBalanceItemTransactionType'
import { ArtistBalanceItemAmount } from './ArtistBalanceItemAmount'

const Container = styled.div`
  display: flex;
  padding: 8px 0px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  align-self: stretch;
  background-color: ${({ theme }) => theme.color.white};
`

const ContainerWithSubItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const SubItemContainer = styled.div`
  display: flex;
  padding: 8px 0px 8px 28px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  align-self: stretch;
  background-color: ${({ theme }) => theme.color.white};
`

type ArtistBalanceItem = {
  id: string
  text: string
  amount: string
  positive?: boolean
  icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string
    }
  >
}

export type ArtistBalanceItemProps = ArtistBalanceItem & {
  date: string
  bold?: boolean
  subText?: string | null
  boldAmount?: boolean
  subItems?: ArtistBalanceItem[]
}
export type CuratorBalanceItemProps = Pick<
  ArtistBalanceItemProps,
  'text' | 'amount' | 'positive' | 'icon' | 'date' | 'subText' | 'id'
>
export const UnionBalanceItem: React.FC<ArtistBalanceItemProps> = (props) => {
  const {
    amount,
    date,
    positive,
    bold,
    text,
    subItems,
    icon,
    subText,
    boldAmount,
  } = props

  if (subItems?.length) {
    return (
      <ContainerWithSubItems>
        <Container>
          <ArtistBalanceItemDate date={date} />
          <ArtistBalanceItemTransactionType
            subText={subText}
            bold={bold}
            icon={icon}
            text={text}
          />
          <ArtistBalanceItemAmount
            amount={amount}
            positive={positive}
            bold={boldAmount}
          />
        </Container>
        {subItems.map((subItem) => (
          <SubItemContainer key={subItem.text}>
            <ArtistBalanceItemDate date={''} />
            <ArtistBalanceItemTransactionType
              icon={subItem.icon}
              text={subItem.text}
            />
            <ArtistBalanceItemAmount
              amount={subItem.amount}
              positive={subItem.positive}
            />
          </SubItemContainer>
        ))}
      </ContainerWithSubItems>
    )
  }
  // If there are no subItems, render the main item only
  return (
    <Container>
      <ArtistBalanceItemDate date={date} />
      <ArtistBalanceItemTransactionType
        subText={subText}
        bold={bold}
        icon={icon}
        text={text}
      />
      <ArtistBalanceItemAmount
        amount={amount}
        positive={positive}
        bold={boldAmount}
      />
    </Container>
  )
}
